import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api';
export const MEDIA_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/storage';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    } else if (error.response && error.response.status === 403) {
      // Forbidden — authenticated but not allowed (e.g. non-admin hitting an
      // admin endpoint). Send to the Forbidden page instead of a broken view.
      if (window.location.pathname !== '/403') {
        window.location.href = '/403';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
